import { createFeatureSelector, createSelector } from '@ngrx/store';

const getPortalState = createFeatureSelector('PORTAL_STORE');

export const getTileSlice = createSelector(
  getPortalState,
  (state: any) => state.tiles,
);

export const getTilesLoadedStatus = createSelector(
  getTileSlice,
  (state: any) => state.loaded,
);

export const getTilesList = createSelector(
  getTileSlice,
  (state: any) => state.tileList,
);
